import { EducationContainer } from "app/components/educationbar/educationContainer";
import { useEducationBarProminentContext } from "app/components/educationbar/useEducationBarProminentContext";

const EducationContainerProminentBig = () => {
    const { isDismissed, isMinimized, handleDismiss, isProminentEducationBannerShown } =
        useEducationBarProminentContext();

    if (!isDismissed && !isMinimized && isProminentEducationBannerShown) {
        return (
            <EducationContainer
                onCloseEducationComponent={handleDismiss}
                isBig={true}
            />
        );
    }

    return null;
};

export default EducationContainerProminentBig;
